import React from 'react';
import { Entry } from '@belong/types/cms';
import * as renderers from './Entries';

const RenderBlockEntry: React.FC<{ entry: Entry<any> }> = ({ entry }) => {
  const contentType = entry.sys.contentType.sys.id;
  if (contentType in renderers) {
    return renderers[contentType](entry);
  }

  return null;
};

RenderBlockEntry.displayName = 'RenderBlockEntry';

export default RenderBlockEntry;
